import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "group shadow-lg rounded-md bg-white dark:bg-gray-800 flex flex-col" }
const _hoisted_2 = { class: "relative bg-gray-50 dark:bg-gray-900 px-3 border-b-2 border-gray-200 dark:border-gray-800 rounded-t-md flex items-center" }
const _hoisted_3 = { class: "py-2 text-lg text-gray-800 dark:text-white font-bold truncate" }
const _hoisted_4 = {
  key: 1,
  class: "flex-1 self-stretch flex items-center px-1 truncate"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Copy this code to your website:", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "font-bold flex items-center" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-green-600"
}
const _hoisted_11 = {
  key: 3,
  class: "text-red-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpTooltip = _resolveComponent("HelpTooltip")!
  const _component_CodeIcon = _resolveComponent("CodeIcon")!
  const _component_ArrowSmUpIcon = _resolveComponent("ArrowSmUpIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (!!_ctx.$slots.help && !_ctx.isEmbedded)
        ? (_openBlock(), _createBlock(_component_HelpTooltip, {
            key: 0,
            class: "ml-1"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "help")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (!!_ctx.$slots.action && !_ctx.isEmbedded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _renderSlot(_ctx.$slots, "action")
          ]))
        : _createCommentVNode("", true),
      (_ctx.showEmbedButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "absolute z-10 p-1 m-1 rounded-sm top-full right-0 transition-all duration-75 text-gray-500 text-opacity-30 hover:text-opacity-60 hover:bg-gray-600 hover:bg-opacity-10 focus-visible:text-opacity-60 focus-visible:bg-gray-600 focus-visible:bg-opacity-10 focus-visible:opacity-100 opacity-0 group-hover:opacity-100 z-40",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEmbedModalOpen = true))
          }, [
            _createVNode(_component_CodeIcon, { class: "w-6" })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showEmbedButton)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          open: _ctx.isEmbedModalOpen,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEmbedModalOpen = false)),
          title: "Embed Code",
          prose: ""
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createElementVNode("input", {
              type: "text",
              value: _ctx.embedCode,
              class: "w-full cursor-pointer bg-gray-300 font-mono text-gray-700 py-1 px-2 rounded-md",
              style: {"min-width":"400px"},
              readonly: "",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
            }, null, 8, _hoisted_7)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.copyState === 'pending')
                ? (_openBlock(), _createBlock(_component_ArrowSmUpIcon, {
                    key: 0,
                    class: "w-6 text-gray-700"
                  }))
                : _createCommentVNode("", true),
              (_ctx.copyState === 'pending')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Click to copy"))
                : _createCommentVNode("", true),
              (_ctx.copyState === 'success')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Copied!"))
                : _createCommentVNode("", true),
              (_ctx.copyState === 'failure')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Failed to copy"))
                : _createCommentVNode("", true),
              (_ctx.copyState === 'pending')
                ? (_openBlock(), _createBlock(_component_ArrowSmUpIcon, {
                    key: 4,
                    class: "w-6 text-gray-700"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}